import { Route } from 'react-router-dom';
import { RequireAdmin } from '../../../../../common/SharedComponents';
import { LoanPageType, LoanStatusType } from '../../../../../loans/common/LoanConstants';
import LoansLandingPageGeneric from '../../../../../loans/LoansLandingPageGeneric';
import { LoansWorkspacePage } from '../../../../../loans/LoansWorkspacePage/LoansWorkspacePage';

export default function LoansRepaidRoutes() {
    return (
        <>
            <Route
                path='/loans/repaid/loc'
                element={
                    <RequireAdmin>
                        <LoansLandingPageGeneric
                            pageType={LoanPageType.LOC}
                            statusId={LoanStatusType.Repaid}
                        />
                    </RequireAdmin>
                }
            />
            <Route
                path='/loans/repaid/construction'
                element={
                    <RequireAdmin>
                        <LoansLandingPageGeneric
                            pageType={LoanPageType.Construction}
                            statusId={LoanStatusType.Repaid}
                        />
                    </RequireAdmin>
                }
            />
            <Route
                path='/loans/repaid/rental'
                element={
                    <RequireAdmin>
                        <LoansLandingPageGeneric
                            pageType={LoanPageType.Rental}
                            statusId={LoanStatusType.Repaid}
                        />
                    </RequireAdmin>
                }
            />
            <Route
                path='/loans/repaid/buildrent'
                element={
                    <RequireAdmin>
                        <LoansLandingPageGeneric
                            pageType={LoanPageType.BuildRent}
                            statusId={LoanStatusType.Repaid}
                        />
                    </RequireAdmin>
                }
            />
            <Route
                path='/loans/repaid/fixflip'
                element={
                    <RequireAdmin>
                        <LoansLandingPageGeneric
                            pageType={LoanPageType.FixFlip}
                            statusId={LoanStatusType.Repaid}
                        />
                    </RequireAdmin>
                }
            />
            <Route
                path='/loans/repaid/land'
                element={
                    <RequireAdmin>
                        <LoansLandingPageGeneric
                            pageType={LoanPageType.Land}
                            statusId={LoanStatusType.Repaid}
                        />
                    </RequireAdmin>
                }
            />
            <Route
                path='/loans/repaid/model'
                element={
                    <RequireAdmin>
                        <LoansLandingPageGeneric
                            pageType={LoanPageType.Model}
                            statusId={LoanStatusType.Repaid}
                        />
                    </RequireAdmin>
                }
            />
            <Route
                path='/loans/repaid/bridge'
                element={
                    <RequireAdmin>
                        <LoansLandingPageGeneric
                            pageType={LoanPageType.Bridge}
                            statusId={LoanStatusType.Repaid}
                        />
                    </RequireAdmin>
                }
            />
            <Route
                path='/loans/repaid'
                element={
                    <RequireAdmin>
                        <LoansWorkspacePage status={LoanStatusType.Repaid} />
                    </RequireAdmin>
                }
            />
        </>
    );
}
